/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendSalaryDto } from '../../models/backend-salary-dto';
import { BackendSalaryRequestDto } from '../../models/backend-salary-request-dto';

export interface OpexesSalaryCreate$FormData$Params {
  body: BackendSalaryRequestDto;
}

export function opexesSalaryCreate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: OpexesSalaryCreate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendSalaryDto>> {
  const rb = new RequestBuilder(rootUrl, opexesSalaryCreate$FormData.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendSalaryDto>;
    }),
  );
}

opexesSalaryCreate$FormData.PATH = '/api/opexes/salary/';
